var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-details"},[_c('tr',[_c('td',[_c('label',[_vm._v(_vm._s(_vm.$t('operators.details.settings_stop_prefix')))])]),_c('td',[_vm._v(_vm._s(_vm.details.stop_prefix))])])])}
var staticRenderFns = []

export { render, staticRenderFns }